import React, { useState } from 'react';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      src: "https://customer-assets.emergentagent.com/job_reality-bender/artifacts/wuf3g7wr_OCvsEqJC.jpg",
      title: "Behind the Stage",
      description: "Simon poses with new illusion that he designed.",
      category: "Behind the Scenes",
      type: "image"
    },
    {
      id: 2,
      src: "https://customer-assets.emergentagent.com/job_reality-bender/artifacts/j9dgdxvu_superturbine.jpg",
      title: "The Super Turbine Illusion",
      description: "An exclusive look at the massive turbine apparatus - one of the most spectacular new illusions being developed for the show. This engineering marvel will leave audiences speechless.",
      category: "New Illusions",
      type: "image"
    },
    {
      id: 3,
      src: "https://customer-assets.emergentagent.com/job_reality-bender/artifacts/sjheq0bg_audienceuse.jpg",
      title: "Mind Reading with Audience",
      description: "Simon performs his incredible mind-reading effects with audience volunteers, using their thoughts to bring lasting memories.",
      category: "Audience Interaction",
      type: "image"
    },
    {
      id: 4,
      src: "https://customer-assets.emergentagent.com/job_reality-bender/artifacts/hgtej6dy_Rubiks%20cube%281%29.mp4",
      title: "Lightning Fast Magic",
      description: "Magic visually amazing and LIVE no AI generated video!",
      category: "Audience Interaction",
      type: "video"
    },
    {
      id: 5,
      src: "https://customer-assets.emergentagent.com/job_reality-bender/artifacts/jp35jsua_talkshow1.mp4",
      title: "Close Up Card Miracles",
      description: "Showing event participants miracles that are close as can be.",
      category: "Audience Interaction",
      type: "video"
    },
    {
      id: 6,
      src: "https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/fthhwe97_Crystal%20Casket.mp4",
      title: "Live Performance Video",
      description: "Watch Simon Nomis in action during a live performance, showcasing the energy and magic that makes 'Obscuring Reality' an unforgettable experience.",
      category: "Live Performance",
      type: "video"
    }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section id="gallery" className="py-20 bg-gradient-to-br from-black via-purple-900/20 to-black">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
              <span className="text-purple-400">EXCLUSIVE</span> GALLERY
            </h2>
            <p className="text-xl text-purple-400 max-w-3xl mx-auto leading-relaxed">
              Go behind the scenes and witness the magic in action. From backstage preparations to incredible audience interactions, discover the artistry and joy that makes "Obscuring Reality" an unforgettable experience for everyone involved.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((image) => (
              <div 
                key={image.id}
                className="group relative overflow-hidden rounded-lg cursor-pointer transform transition-all duration-500 hover:scale-105"
                onClick={() => openModal(image)}
              >
                <div className="aspect-square">
                  {image.type === 'video' ? (
                    <video
                      src={image.src}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      muted
                      preload="metadata"
                    />
                  ) : (
                    <img
                      src={image.src}
                      alt={image.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  )}
                </div>
                
                {/* Video Play Button Overlay */}
                {image.type === 'video' && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 bg-purple-600/90 rounded-full flex items-center justify-center group-hover:bg-purple-500/90 transition-colors duration-300">
                      <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M6.5 4.5l9 5.5-9 5.5V4.5z"/>
                      </svg>
                    </div>
                  </div>
                )}

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-100 group-hover:opacity-90 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">{image.title}</h3>
                    <p className="text-gray-300 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                      {image.description}
                    </p>
                  </div>
                </div>

                {/* Hover Effect */}
                <div className="absolute inset-0 border-2 border-purple-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center mt-16">
            <div className="bg-black/50 backdrop-blur-sm rounded-lg p-8 border border-purple-500/20">
              <h3 className="text-3xl font-bold text-white mb-4">
                Become Part of the Magic
              </h3>
              <p className="text-lg text-gray-300 mb-6 max-w-2xl mx-auto">
                These exclusive moments show the incredible joy and wonder that Simon creates with audience participation. You could be the next person celebrating on stage with your own magical victory trophy or the lucky person to vanish in front of the audience!
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            {selectedImage.type === 'video' ? (
              <video
                src={selectedImage.src}
                controls
                autoPlay
                className="max-w-full max-h-full object-contain rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <img
                src={selectedImage.src}
                alt={selectedImage.title}
                className="max-w-full max-h-full object-contain rounded-lg"
              />
            )}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-white bg-black/50 rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/70 transition-colors"
            >
              ✕
            </button>
            {/* Only show text overlay for images, not videos */}
            {selectedImage.type !== 'video' && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
                <p className="text-gray-300 leading-relaxed">
                  {selectedImage.description}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;